import {
  Modal as ChakraModal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button
} from '@chakra-ui/react'

const Modal = ({
  isOpen,
  onClose,
  header,
  showButtons = true, //決定是否顯示按鈕
  ctaBtnText,
  ctaHandler,
  ctaBtnColor = 'blue', // 添加默認顏色為 blue 的新參數
  secondaryBtnIsShow = true,
  secondaryBtnText = '關閉',
  secondaryHandler = () => {},
  children
}) => {
  return (
    <ChakraModal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{header}</ModalHeader>
        <ModalBody>
          {children}
        </ModalBody>
        {
          showButtons && (
            <ModalFooter>
              <Button 
                colorScheme={ctaBtnColor} // 使用傳入的顏色或默認值
                mr={3} 
                onClick={ctaHandler}
              >
                {ctaBtnText}
              </Button>
              <Button 
                display={secondaryBtnIsShow ? 'block' : 'none'} 
                variant='outline' 
                onClick={secondaryHandler}
              >
                {secondaryBtnText}
              </Button>  
            </ModalFooter>
          )
        }
      </ModalContent>
    </ChakraModal>
  )
}

export default Modal